export class NotUniqueError extends Error {
  constructor(message: string = "Not Unique") {
    super(message);
    this.name = "NotUniqueError";
  }
}
